import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { AbsoluteTooltipModule } from '../absolute-tooltip/absolute-tooltip.module'
import { ToggleAdvancedEditComponent } from './toggle-advanced-edit.component'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AbsoluteTooltipModule,
    ],
    declarations: [
        ToggleAdvancedEditComponent,
    ],
    exports: [
        ToggleAdvancedEditComponent,
    ],
})
export class ToggleAdvancedEditModule {
}